/**
 * 日本語 dictionary — keys are the English source strings.
 * Station/stop names stay English for ja (stationMode "en").
 */
export const ja = {
  "(Hong Kong time, UTC+8). Live clock.": "（香港時間、UTC+8）。ライブ時計。",
  "(Hong Kong time, UTC+8). Reset returns to live clock.": "（香港時間、UTC+8）。リセットするとライブ時計に戻ります。",
  "(UTC+8). Reset returns to Now.": "（UTC+8）。リセットすると「今」に戻ります。",
  "(merged official stops + OSRM densify).": "（公式停留所を統合 + OSRM で点を追加）。",
  "(orange). Official stop coords stay fixed (grey ghosts) for identity / merge.": "（オレンジ）。公式停留所の座標は固定のまま（グレーの残像）で、同一性／統合のため維持されます。",
  "*You might still need short station access if you disabled Walk. Plans to a stop/station itself stay listed.": "*徒歩を無効にした場合でも、短距離の駅アクセスが必要な場合があります。停留所・駅自体への経路は引き続き表示されます。",
  ", and": "、および",
  ", you can load a calculated path and edit turning points for moderators to review.": "、計算済みパスを読み込んで曲がり角を編集し、モデレーターのレビューに回せます。",
  "0 path pts": "0 パスポイント",
  "@Bus": "@バス",
  "@LRT": "@軽鉄",
  "@MTR": "@MTR",
  "AEL": "エアポートエクスプレス",
  "About": "このアプリについて",
  "About Travelers": "Travelers について",
  "Add via": "経由を追加",
  "Airport Express (AEL)": "エアポートエクスプレス（AEL）",
  "Alight": "下車",
  "Alight match": "下車マッチ",
  "All done!": "設定完了！",
  "All done! Let's start enjoying your trip with Travelers!": "設定完了！Travelers での旅を楽しみましょう！",
  "All modes": "すべての交通手段",
  "All operators": "すべての事業者",
  "Allow location for origin, or set From manually": "出発地に現在地を使用するか、出発地を手動で設定してください",
  "Also fetches ETAs at the nearest stops and every 5th stop ahead and behind the selected stop, so positions are stitched from more anchors (extra requests per route view).": "最寄り停留所と、選択した停留所の前後 5 つおきの停留所でも ETA を取得し、より多くの基準点から位置を補間します（路線表示ごとにリクエストが増えます）。",
  "App opens the PR with the site bot token (no GitHub login).": "アプリはサイトの bot token で PR を開きます（GitHub ログイン不要）。",
  "App sections": "アプリのセクション",
  "Application code © UNLOOP MORGAN 2026. Apache 2.0 does not grant trademark rights. “MORGAN”, “Travelers”, logos, and product naming may not be reused without permission.": "アプリケーションコード © UNLOOP MORGAN 2026。Apache 2.0 は商標権を付与しません。「MORGAN」「Travelers」、ロゴ、製品名は許可なく再利用できません。",
  "Auto-caches only the app shell (UI, fonts, icons) so ordinary use never burns mobile data. Fares, route/stop data and the basemap are downloaded only when you press “Download offline data” below (≈ 55 MB) — press the button again after updates to refresh it.": "自動キャッシュはアプリのシェル（UI、フォント、アイコン）のみで、通常利用でモバイルデータを消費しません。運賃・路線／停留所データ・ベースマップは、下の「オフラインデータをダウンロード」を押した時だけダウンロードされます（約 55 MB）— 更新後は再度ボタンを押して更新してください。",
  "Back": "戻る",
  "Back online": "オンラインに復帰",
  "Back to search": "検索に戻る",
  "Back to trip": "行程に戻る",
  "Balanced": "バランス",
  "Basemap style and layer definitions (Protomaps).": "ベースマップのスタイルとレイヤー定義（Protomaps）。",
  "Basemap tiles generated from OpenStreetMap (via hk-pmtiles-generation) and served from the Travelers data edge.": "ベースマップタイルは OpenStreetMap（hk-pmtiles-generation 経由）から生成され、Travelers のデータエッジから配信されます。",
  "Beta": "ベータ版",
  "Beta Feature": "ベータ版機能",
  "Beta Features": "ベータ版機能",
  "Beta banner enabled": "ベータ版バナーを有効化しました",
  "Beta banner hidden": "ベータ版バナーを非表示にしました",
  "Beta features": "ベータ版機能",
  "Beta warning banner": "ベータ版注意バナー",
  "Board": "乗車",
  "Board match": "乗車マッチ",
  "Board/alight name fragments required (auto-filled after Load path).": "乗車／下車の名称フラグメントが必要です（パス読み込み後に自動入力されます）。",
  "Bot account": "Bot アカウント",
  "Box-select path points / offsets (B)": "ボックス選択でパスポイント／オフセットを選択（B）",
  "Branch": "支線",
  "Build and toolchain": "ビルドとツールチェーン",
  "Build tool (VoidZero Inc. and Vite contributors).": "ビルドツール（VoidZero Inc. および Vite コントリビューター）。",
  "Bus": "バス",
  "Bus · {cos}": "バス · {cos}",
  "Bus / GMB routes, stops and fares (FARE, ROUTE, RSTOP, STOP tables) plus realtime ETAs (rt.data.gov.hk, data.etabus.gov.hk).": "バス／ミニバスの路線・停留所・運賃（FARE、ROUTE、RSTOP、STOP テーブル）とリアルタイム ETA（rt.data.gov.hk、data.etabus.gov.hk）。",
  "Bus companies": "バス事業者",
  "Bus company": "バス事業者",
  "Bus paths are drawn live from the road network and can miss real alignments (e.g. Mei Tung Street vs the bus terminus). On": "バスの経路は道路ネットワークからリアルタイムに描画されるため、実際の走行ルートとずれる場合があります（例：美東街とバスターミナルの違い）。オン",
  "Bus: route no. · MTR: line code (TWL, ISL, TCL…) · AEL · LRT: route no. (505) · GMB: route code (auto region search)": "バス：路線番号 · MTR：線区コード（TWL、ISL、TCL…）· AEL · 軽鉄：路線番号（505）· ミニバス：路線コード（自動地域検索）",
  "CTB": "シティバス",
  "Cache": "キャッシュ",
  "Cache all data": "すべてのデータをキャッシュ",
  "Cache data on device": "端末にデータをキャッシュ",
  "Cache transit data on this device for offline use and mobile data savings.": "オフライン利用とモバイルデータ節約のため、この端末に交通データをキャッシュします。",
  "Cache: checking…": "キャッシュ：確認中…",
  "Cancel": "キャンセル",
  "Cannot delete path endpoints": "パスの端点は削除できません",
  "Change platforms": "ホームを乗り換え",
  "Change platforms at {station}": "{station} でホームを乗り換え",
  "Check your connection and try again": "接続を確認してもう一度お試しください",
  "Checking edge metadata…": "エッジメタデータを確認中…",
  "China T-Union Cards": "交通連合カード",
  "Choose how to open a review PR on": "レビュー PR の開き方を選択",
  "Choose operator + route →": "事業者 + 路線を選択 →",
  "Choose your default fare ticket type for trip plans.": "旅程プランで運賃の見積もりに使う既定の切符の種類を選択してください。",
  "Choose your preferred language": "お好みの言語を選択してください",
  "Circular": "循環",
  "Citybus": "シティバス",
  "Citybus (CTB)": "シティバス（CTB）",
  "Clear": "クリア",
  "Clear selection": "選択をクリア",
  "Clear via": "経由をクリア",
  "Click anywhere on the map for {field}": "地図上の任意の場所をクリックして{field}を設定",
  "Close": "閉じる",
  "Cloud": "クラウド",
  "Cloud: live data first, downloaded copy as the offline fallback. Local: serve the downloaded copy directly to save mobile data.": "クラウド：ライブデータを優先し、ダウンロード済みコピーをオフラインの代替として使用。ローカル：ダウンロード済みコピーを直接使用してモバイルデータを節約。",
  "Community data feed": "コミュニティデータフィード",
  "Concessionary fare on domestic routes; excl. AEL, EAL First Class, Lo Wu & Lok Ma Chau": "市内路線は割引運賃；AEL、東鉄頭等、羅湖、落馬洲は対象外",
  "Confirm": "確認",
  "Confirm (Enter) or Revert (Esc) Follow roads first": "先に道路追従を確認（Enter）または元に戻してください（Esc）",
  "Confirm or Revert Follow roads first": "先に道路追従を確認または元に戻してください",
  "Confirm or Revert the current Follow roads result first": "先に道路追従の結果を確認または元に戻してください",
  "Confirm or Revert the path first": "先にパスを確認または元に戻してください",
  "Contactless Bank Cards": "非接触型銀行カード",
  "Contribute": "投稿",
  "Contribute closed — desktop only": "投稿を閉じました — デスクトップ限定",
  "Contribute route path": "路線経路を投稿",
  "Copy JSON": "JSON をコピー",
  "Could not copy — use Download instead": "コピーできませんでした — 代わりにダウンロードしてください",
  "Could not get location": "現在地を取得できませんでした",
  "Could not import JSON": "JSONをインポートできませんでした",
  "Could not load route path": "路線パスを読み込めませんでした",
  "Could not reach data edge.": "データエッジに接続できませんでした。",
  "Could not reach the submit API.": "送信APIに接続できませんでした。",
  "Could not resolve LRT coords for route {r}": "路線 {r} の軽鉄座標を解決できませんでした",
  "Couldn’t load nearby routes": "周辺の路線を読み込めませんでした",
  "Couldn’t load routes": "路線を読み込めませんでした",
  "Current location": "現在地",
  "Data cache": "データキャッシュ",
  "Data cache enabled": "オフラインデータキャッシュを有効化",
  "Data update available": "データ更新があります",
  "Data: MTR open data · Protomaps · OpenStreetMap contributors.": "データ：MTR オープンデータ · Protomaps · OpenStreetMap コントリビューター。",
  "Dataset status": "データセットの状態",
  "Default:": "デフォルト：",
  "Delete ({n})": "削除（{n}）",
  "Delete All Data on This Device": "この端末のすべてのデータを削除",
  "Delete all data": "すべて削除",
  "Delete all data?": "すべてのデータを削除しますか？",
  "Delete selected": "選択を削除",
  "Deleted {n} points": "{n} ポイントを削除しました",
  "Deleted {n} points · {m} remain · Undo available": "{n} ポイント削除 · {m} 残り · 元に戻せます",
  "Deletes every cached byte, preference and onboarding state, then restarts the app.": "すべてのキャッシュデータ、設定、オンボーディング状態を削除してから、アプリを再起動します。",
  "Densifying segments OSRM can handle…": "OSRMが処理できるようセグメントを高密度化中…",
  "Departure": "出発",
  "Departure · Now (UTC+8)": "出発 · 今（UTC+8）",
  "Departure · {label}": "出発 · {label}",
  "Departure time (Hong Kong, UTC+8)": "出発時刻（香港、UTC+8）",
  "Departure · {time}": "出発 · {time}",
  "Desktop only · mouse/trackpad recommended.": "デスクトップのみ · マウス／トラックパッド推奨。",
  "Destination": "目的地",
  "Developer": "開発者",
  "Direction": "方面",
  "Done": "完了",
  "Download GTFS": "GTFS をダウンロード",
  "Download JSON": "JSON をダウンロード",
  "Download JSON copy": "JSON のコピーをダウンロード",
  "Download PMTiles": "PMTiles をダウンロード",
  "Download failed": "ダウンロードに失敗しました",
  "Download offline data": "オフラインデータをダウンロード",
  "Download or copy the JSON and share it with moderators if needed.": "必要に応じてJSONをダウンロードまたはコピーし、モデレーターと共有してください。",
  "Downloading offline data…": "オフラインデータをダウンロード中…",
  "Downloads": "ダウンロード",
  "Drag a box on the map · +drag to add · amber = offset from route · red = selected · remove": "地図上でドラッグしてボックス選択 · +ドラッグで追加 · 琥珀 = 路線からオフセット · 赤 = 選択中 · 削除",
  "Draw or load a path first (need ≥ 2 points)": "先にパスを描画または読み込んでください（2点以上必要）",
  "Drawing route…": "経路を描画中…",
  "Drop a .json contribution file": ".jsonの投稿ファイルをドロップしてください",
  "E2E testing only — not shipped in the app bundle.": "E2E テスト専用 — アプリバンドルには含まれません。",
  "EAL First Class": "東鉄頭等",
  "ETA route browser": "ETA 路線ブラウザ",
  "ETA unavailable · checked {t}": "ETA を取得できません · {t} に確認",
  "East Rail Line First Class": "東鉄線頭等",
  "Edit mode": "編集モード",
  "Edit path turns (hollow green) and/or": "経路の曲がり角（中空の緑）を編集、または／かつ",
  "Enable": "有効にする",
  "Enter a Destination/Route": "目的地／路線を入力",
  "Enter a route number (e.g. 38, S1, E11).": "路線番号を入力してください（例：38、S1、E11）。",
  "Enter an MTR line code: TWL, ISL, KTL, TML, EAL, TCL, TKL, SIL, DRL, AEL": "MTR路線コードを入力してください：TWL、ISL、KTL、TML、EAL、TCL、TKL、SIL、DRL、AEL",
  "Est. arrive": "到着予定",
  "Estimated arrival (Hong Kong time)": "到着予定時刻（香港時間）",
  "Expand or collapse": "展開／折りたたみ",
  "Expand or collapse panel": "パネルを展開／折りたたみ",
  "Fare": "運賃",
  "Fare · {type}": "運賃 · {type}",
  "Fare tables unavailable — times still work": "運賃表を取得できません — 時刻は引き続き表示されます",
  "Fares, line / LRT routes and stops, MTR Bus schedules.": "運賃、路線／軽鉄の路線と停留所、MTR バスの時刻表。",
  "Fastest": "最速",
  "Fetch more live data": "ライブデータをさらに取得",
  "Fetch more live data disabled": "「ライブデータをさらに取得」を無効にしました",
  "Fetch more live data enabled": "「ライブデータをさらに取得」を有効にしました",
  "Fetch the full dataset for offline use. This will be the main data source if preferred in the “Prefer data source” setting above.": "オフライン用に完全なデータセットを取得します。上の「データソースの優先」設定で選択された場合、これが主要なデータソースになります。",
  "Fewer transfers preferred": "乗り換えが少ない方を優先",
  "Filter stops:": "停留所を絞り込み：",
  "Finishing…": "終了処理中…",
  "First-party code": "自社コード",
  "Fixed time": "指定時刻",
  "Follow roads": "道路に沿う",
  "Follow roads calculation": "道路に沿った計算",
  "Follow roads confirmed": "道路追従を確認しました",
  "Follow roads confirmed · {n} path pts · Undo still available · Hide overlay when done": "道路追従を確認 · {n} パスポイント · 元に戻せます · 完了したらオーバーレイを非表示に",
  "Follow roads reverted": "道路追従を元に戻しました",
  "Follow roads reverted · {n} path pts restored": "道路追従を元に戻しました · {n} パスポイントを復元",
  "Recalculate path": "経路を再計算",
  "Recalc preview: {ins} road pts via {n} section(s) · {before}→{after} pts — Confirm or Revert": "再計算プレビュー：道路経由で {ins} ポイント · {n} 区間 · {before}→{after} 箇所 — 確認または取り消し",
  "Couldn't reroute along roads — OSRM is unavailable. Path unchanged.": "道路に沿って再構成できませんでした — OSRM を利用できません。経路は変更されていません。",
  "Recalculate needs a connection — you appear to be offline.": "再計算には接続が必要です — オフラインのようです。",
  "Road assistant: recalculating section {i}/{n}…": "道路アシスタント：区間 {i}/{n} を再計算中…",
  "Road assistant stopped: OSRM is rate-limiting or down — try again in a minute.": "道路アシスタントを停止：OSRM がレート制限中か到達不能です — 1 分後に再試行してください。",
  "Follow-roads overlay hidden": "道路追従オーバーレイを非表示にしました",
  "Add blocker": "ブロッカーを追加",
  "Blocker added": "ブロッカーを追加しました",
  "Blocker added — Follow roads will avoid this junction": "ブロッカーを追加 — 道路追従はこの交差点を避けます",
  "Blocker already there": "すでにブロッカーがあります",
  "Blocker placement off": "ブロッカー配置を終了",
  "Blocker removed": "ブロッカーを削除しました",
  "Blockers cleared": "ブロッカーを消去しました",
  "blockers": "ブロッカー",
  "Cannot set the first point as last": "最初の点を終点にはできません",
  "Clear blockers": "ブロッカーを消去",
  "Click the map to drop a blocker": "地図をクリックしてブロッカーを置く",
  "Focused point {n} · 1 = start here · 2 = last here": "点 {n} を選択中 · 1 = 始点 · 2 = 終点",
  "Junction blocker (avoid this road)": "交差点ブロッカー（この道路を避ける）",
  "Line now ends here": "線はここで終わります",
  "Line start moved here": "線の始点をここに移しました",
  "loop": "循環",
  "Mode: Path turns (V) — drag rings · arrows show direction · 1 start · 2 last": "モード：経路の曲がり（V）— リングをドラッグ · 矢印が方向 · 1 始点 · 2 終点",
  "Mode: Select (B) — box-select · Follow roads snaps selected only": "モード：選択（B）— 範囲選択 · 道路追従は選択点のみ",
  "Need a focused path point — click a green ring first": "先に緑のリングをクリックして点を選んでください",
  "Zoom Chord": "ズームコード",
  "Zoom Chord disabled": "ズームコードをオフにしました",
  "Zoom Chord enabled": "ズームコードをオンにしました",
  "On non-contributed bus routes, road-snap the GTFS line onto OpenStreetMap roads when you zoom in. Uses the on-device street graph with OSRM only as backup.": "未貢献のバス路線では、ズーム時に GTFS 線を OpenStreetMap の道路へスナップします。端末内の道路グラフで経路を作成し、OSRM は予備としてのみ使用します。",
  "Path already ends here": "すでにここで終わっています",
  "Path already starts here": "すでにここが始点です",
  "Path end set · {n} pts remain": "終点を設定 · {n} 点が残っています",
  "Path mode: drag rings · click a ring then 1/2 for start/last · Shift+click blocker · R Follow roads": "経路モード：リングをドラッグ · リングをクリックして 1/2 で始点／終点 · Shift+クリックでブロッカー · R 道路追従",
  "Path rotated · this point is now the start": "経路を回転 · この点が始点です",
  "Placing blockers — click the wrong road at a junction · Esc to stop": "ブロッカー配置 — 交差点の誤った道路をクリック · Esc で終了",
  "Select mode: Follow roads snaps selected points only. Select some, or leave Select mode to snap all.": "選択モード：道路追従は選択点のみ吸着します。点を選ぶか、選択モードを終了して全点を吸着してください。",
  "Select mode: box-select · Follow roads snaps selected points only · Del removes": "選択モード：範囲選択 · 道路追従は選択点のみ · Del で削除",
  "Select mode (B) — Follow roads snaps selected points only": "選択モード（B）— 道路追従は選択点のみ吸着",
  "Select points first, or press V to snap the whole path": "先に点を選ぶか、V で経路全体を吸着",
  "Service disruption": "運行障害",
  "Set as last": "終点にする",
  "START": "始",
  "END": "終",
  "Start here": "ここを始点に",
  "Cutoff stop (by sequence — not the overlapping pin)": "区切り停留所（順序で選ぶ — 重なったピンは使わない）",
  "hidden": "非表示",
  "Previous stop": "前の停留所",
  "Next stop": "次の停留所",
  "Hide before": "前を隠す",
  "Hide after": "後を隠す",
  "Show all": "すべて表示",
  "Showing all": "すべて表示しました",
  "Showing all stops and path": "停留所と経路をすべて表示",
  "Click a stop pin first, then Hide before / Hide after": "先に停留所ピンをクリックしてから、前／後を隠してください",
  "Nothing before the first stop": "最初の停留所の前にはありません",
  "Nothing after the last stop": "最後の停留所の後にはありません",
  "showing {n}/{m}": "{n}/{m} を表示",
  "Showing from #{n} {name} · hidden {k} stops before · 0 to show all": "#{n} {name} から表示 · 前の {k} 停留所を非表示 · 0 ですべて表示",
  "Showing through #{n} {name} · hidden {k} stops after · 0 to show all": "#{n} {name} まで表示 · 後の {k} 停留所を非表示 · 0 ですべて表示",
  "Focused stop #{n} {name} · [ hide before · ] hide after · 0 show all": "#{n} {name} を選択 · [ 前を隠す · ] 後を隠す · 0 すべて表示",
  "Mode: Visual stops (S) — click a stop then [ hide before / ] hide after": "モード：停留所（S）— ピンをクリックして [ 前を隠す / ] 後を隠す",
  "Visual stops: click a pin then [ / ] to hide the other half of a circular · drag to adjust": "停留所：ピンをクリックし [ / ] で循環のもう半分を隠す · ドラッグで調整",
  "Fonts": "フォント",
  "Free MTR link": "MTR 無料連絡通路",
  "Free MTR link: {from} → {to}": "MTR 無料連絡通路：{from} → {to}",
  "From": "出発地",
  "From plan": "プランから",
  "Full route": "全路線",
  "GMB": "ミニバス",
  "GMB (green minibus)": "ミニバス（グリーンミニバス）",
  "GMB route code required": "GMB路線コードが必要です",
  "GMB route {code} not found. Try the public code (e.g. 1, 44A).": "GMB路線 {code} が見つかりません。公開コード（例：1、44A）をお試しください。",
  "GTFS feed builder (© 2025 Wheels Transit) behind hk.gtfs.zip and the routing graph; feed data is derived from the government sources above.": "hk.gtfs.zip と経路探索グラフの基盤となる GTFS フィードビルダー（© 2025 Wheels Transit）；フィードデータは上記の政府ソースから派生。",
  "GTFS → .wheelsrouter graph compiler, run in CI (wheels-router-nano ecosystem; not shipped).": "GTFS → .wheelsrouter グラフコンパイラ、CI で実行（wheels-router-nano エコシステム；同梱されません）。",
  "Getting your location…": "現在地を取得中…",
  "GitHub Repository": "GitHub リポジトリ",
  "GitHub account": "GitHub アカウント",
  "GitHub login failed": "GitHubログインに失敗しました",
  "GitHub login finished": "GitHubログインが完了しました",
  "GitHub login required": "GitHubログインが必要です",
  "Gov open data terms": "政府オープンデータの利用条件",
  "Green minibus routes, stops and ETAs.": "グリーンミニバスの路線、停留所、ETA。",
  "Hide ETA to browse the full stop list": "ETA を非表示にして全停留所を表示",
  "Hide beta banner for this session": "このセッション中はベータ版バナーを非表示",
  "Hide beta banner?": "ベータ版バナーを非表示にしますか？",
  "Hide calculation overlay": "計算オーバーレイを非表示",
  "High (more data)": "高（データ多め）",
  "High accuracy": "高精度",
  "Holiday": "休日",
  "Hong Kong Community GTFS": "香港コミュニティ GTFS",
  "Hong Kong map": "香港マップ",
  "Hong Kong transit map & trip planner. Routes use the public GTFS graph (RAPTOR) with Octopus adult fare estimates. Search supports": "香港の交通マップ＆乗換案内。路線は公開 GTFS グラフ（RAPTOR）を使用し、オクトパス大人運賃の概算付き。検索対応",
  "I agree to all terms and policies": "すべての規約とポリシーに同意します",
  "I agree to the Terms of Service and Privacy Policy": "利用規約およびプライバシーポリシーに同意します",
  "I understand": "理解しました",
  "Import JSON": "JSON をインポート",
  "Import a downloaded contribution JSON to continue editing": "ダウンロードした投稿 JSON をインポートして編集を続行",
  "Import failed": "インポートに失敗しました",
  "Imported JSON · {n} points": "JSONをインポート · {n} ポイント",
  "Imported {id} · {n} path pts · {m} visual stops · continue editing": "{id} をインポート · パスポイント {n} · ビジュアル停留所 {m} · 編集を継続",
  "In-station interchange": "駅構内乗り換え",
  "In-station interchange at {place}": "{place} で駅構内乗り換え",
  "Inbound / I / DOWN / seq 2": "下り／I／DOWN／seq 2",
  "Indoor interchange": "屋内乗り換え",
  "Indoor interchange: {from} → {to}": "屋内乗り換え：{from} → {to}",
  "Invalid JSON object": "無効なJSONオブジェクトです",
  "Invalid place": "無効な場所です",
  "JSON copied": "JSONをコピーしました",
  "JSON copied to clipboard": "JSONをクリップボードにコピーしました",
  "JSON downloaded": "JSONをダウンロードしました",
  "JSON needs coordinates with at least 2 [lon,lat] points": "JSONには少なくとも2つの[lon,lat]座標ポイントが必要です",
  "JoyYou $2/20% scheme; full adult for AEL, Lo Wu, Lok Ma Chau & Racecourse": "JoyYou の $2／20% 制度；AEL、羅湖、落馬洲、競馬場は大人運賃",
  "KMB": "KMB",
  "KMB / Citybus": "KMB／シティバス",
  "KMB / LWB": "九巴／龍運",
  "KMB/LWB": "九巴／龍運",
  "Keep banner": "バナーを残す",
  "LIVE": "リアルタイム",
  "LRT": "軽鉄",
  "LRT route CSV empty": "軽鉄路線CSVが空です",
  "LRT route number required (e.g. 505, 507, 610)": "軽鉄の路線番号が必要です（例：505、507、610）",
  "LWB": "LWB",
  "Language": "言語",
  "Language · {label}": "言語 · {label}",
  "Last point removed": "最後のポイントを削除しました",
  "Later": "後で",
  "Least fare": "最安運賃",
  "Licenses": "ライセンス",
  "Light Rail": "軽鉄",
  "Light Rail (LRT)": "軽鉄（LRT）",
  "Live": "リアルタイム",
  "Live ETAs · {liveN}/{total} routes · {t} · refreshes every 1 min": "リアルタイム ETA · {liveN}/{total} 路線 · {t} · 1 分ごとに更新",
  "Live ETAs failed — will retry": "リアルタイム ETA を取得できません — 再試行します",
  "Live OSRM path · {stops} stops · {n} pts (no matching published path). Press R to follow roads.": "ライブOSRMパス · 停留所 {stops} · {n} pts（一致する公開パスなし）。Rで道路追従。",
  "Live Position Engine": "ライブ位置エンジン",
  "Live Position Engine (Prediction-based)": "ライブ位置エンジン（予測ベース）",
  "Live Position Engine disabled": "ライブ位置エンジンを無効にしました",
  "Live Position Engine enabled": "ライブ位置エンジンを有効にしました",
  "Live arrivals": "リアルタイム到着",
  "Live bus positions": "バスのリアルタイム位置",
  "Live bus positions disabled": "ライブバス位置を無効にしました",
  "Live bus positions enabled": "ライブバス位置を有効にしました",
  "Live est. arrive": "リアルタイム到着予定",
  "Live {liveN} · Scheduled {schedN} · {total} routes · {t}": "リアルタイム {liveN} · 時刻表 {schedN} · 全 {total} 路線 · {t}",
  "Load a calculated path or draw at least 2 points.": "計算済みパスを読み込むか、2点以上描画してください。",
  "Load a path first": "先にパスを読み込んでください",
  "Load calculated path": "計算済み経路を読み込み",
  "Load failed": "読み込みに失敗しました",
  "Load path": "経路を読み込み",
  "Load path not supported for operator {ag} yet — use From plan or draw": "事業者 {ag} のパス読み込みには未対応です — 「プランから」または手描きを使用してください",
  "Loaded calculated path from plan ({n} pts). Follow roads (R) to hug streets, then edit.": "プランから計算済みパスを読み込み（{n} pts）。Rで道路追従して道路に沿わせてから編集してください。",
  "Loaded path from current plan": "現在のプランからパスを読み込みました",
  "Loading WASM router…": "WASM ルーターを読み込み中…",
  "Loading nearby routes…": "周辺の路線を読み込み中…",
  "Loading route…": "路線を読み込み中…",
  "Loading routes…": "路線を読み込み中…",
  "Loading stops + checking published overrides…": "停留所を読み込み中 + 公開オーバーライドを確認中…",
  "Loading {co} {id}…": "{co} {id} を読み込み中…",
  "Loading {n} pinned route{s}…": "固定中の {n} 停留所{s} を読み込み中…",
  "Loading {n} pinned stop{s}…": "固定中の {n} 停留所{s} を読み込み中…",
  "Loads this route’s published override if any; otherwise a": "この路線の公開オーバーライドがあれば読み込み、なければ",
  "Local": "ローカル",
  "Location permission denied": "位置情報の許可が拒否されました",
  "Location request timed out": "位置情報のリクエストがタイムアウトしました",
  "Location unavailable": "位置情報を取得できません",
  "Log in and open a PR from": "ログインして",
  "Log in with GitHub": "GitHub でログイン",
  "Log in with GitHub first (or switch to Bot account)": "先にGitHubにログインしてください（またはBotアカウントに切替）",
  "Log in with GitHub to submit with your account, or switch to Bot account.": "GitHubにログインして自分のアカウントで送信するか、Botアカウントに切り替えてください。",
  "Log out": "ログアウト",
  "Logged out of GitHub": "GitHubからログアウトしました",
  "Lower fare preferred": "運賃が安い方を優先",
  "MTR": "MTR",
  "MTR (heavy rail)": "MTR（重鉄）",
  "MTR Corporation open data": "MTRコーポレーションのオープンデータ",
  "MTR ends": "MTR 終点",
  "MTR open data terms": "MTRオープンデータ規約",
  "MTR preferred": "MTR 優先",
  "Main": "メイン",
  "Map": "地図",
  "Map data and services": "地図データとサービス",
  "Map error: {msg}": "地図エラー：{msg}",
  "Map failed to load tiles": "地図タイルを読み込めませんでした",
  "Map ready · streaming hongkong.pmtiles": "地図の準備完了 · hongkong.pmtiles をストリーミング",
  "Map rendering engine (MapLibre contributors).": "地図レンダリングエンジン（MapLibre コントリビューター）。",
  "Map rendering paused — recovering…": "地図レンダリングを一時停止 — 復旧中…",
  "Map resumed": "地図を再開しました",
  "Map unavailable": "地図を表示できません",
  "Map didn't recover — reloading…": "地図が復旧しません — 再読み込み中…",
  "Metadata unavailable — map may still load from PMTiles URL": "メタデータを取得できません — 地図は PMTiles URL から読み込める場合があります",
  "Minimise journey time": "所要時間を最短に",
  "Mode": "モード",
  "Mode · {day}": "モード · {day}",
  "Mode: Path turns (V) — drag hollow green rings": "モード：経路の曲がり角（V）— 中空の緑のリングをドラッグ",
  "Modes · {methods}": "モード · {methods}",
  "MTR Bus": "MTR バス",
  "Meet at {place}": "{place} で待ち合わせ",
  "Meet friends here": "ここで待ち合わせ",
  "Meet friends here (optional)": "ここで待ち合わせ（任意）",
  "Nearby": "近く",
  "A new version of MORGAN Travelers is ready. Reload now to get it?": "MORGAN Travelers の新しいバージョンが利用可能です。今すぐ再読み込みしますか？",
  "Bus · {label}": "バス · {label}",
  "Data cache disabled — data source reset to Cloud": "オフラインデータキャッシュを無効化 — データソースをクラウドにリセット",
  "Fare · {fare}": "運賃 · {fare}",
  "Mode · {mode}": "モード · {mode}",
  "Modes · {modes}": "交通手段 · {modes}",
  "MORGAN Travelers (main app)": "MORGAN Travelers（メインアプリ）",
  "N/A": "なし",
  "NLB": "NLB",
  "Need at least 2 path points": "パスポイントが最低2つ必要です",
  "Next": "次へ",
  "No GMB stops for {code} seq {seq}": "GMB {code} の seq {seq} の停留所が見つかりません",
  "No LRT stops for route {r} direction {dir}. Check route no. (e.g. 505).": "路線 {r} 方向 {dir} の軽鉄停留所が見つかりません。路線番号を確認してください（例：505）。",
  "No departure": "発車なし",
  "No departure data": "発車データなし",
  "No draft to copy": "コピーする下書きがありません",
  "No draft to download": "ダウンロードする下書きがありません",
  "No large offsets found": "大きなオフセットはありません",
  "No nearby routes": "周辺に路線がありません",
  "No offset points over {m}m — path is clean enough": "{m}mを超えるオフセットポイントはありません — パスは十分クリーンです",
  "No override for this route — using similar published path from {from} (shared corridor) · {n} pts. Edit & submit your own.": "この路線にオーバーライドはありません — {from} の類似公開パスを使用（共有区間）· {n} pts。編集して自分で送信してください。",
  "No places found": "場所が見つかりません",
  "No places found — try “Yuen Long Station”, @MTR, or tap the map": "場所が見つかりません — 「Yuen Long Station」、@MTR をお試しください。または地図をタップ",
  "No places match “{q}”": "「{q}」に一致する場所がありません",
  "No plan selected — search a route instead": "プランが選択されていません — 代わりに路線を検索してください",
  "No points in box (endpoints are protected)": "ボックス内にポイントがありません（端点は保護されています）",
  "No points selected": "ポイントが選択されていません",
  "No routes found": "路線が見つかりません",
  "No routes found — try other points": "路線が見つかりません — 別の地点をお試しください",
  "No routes found through via — try another meeting point": "この経由地を通る路線が見つかりません — 別の待ち合わせ場所をお試しください",
  "No routes found.": "路線が見つかりません。",
  "No routes match “{q}”": "「{q}」に一致する路線がありません",
  "No routes or places for “{q}”": "「{q}」の路線または場所が見つかりません",
  "No station coords found for MTR {line}": "MTR {line}の駅座標が見つかりません",
  "No stop list for {co} {id}.": "{co} {id} の停留所リストがありません。",
  "No stops found for {ag} {r} ({dir})": "{ag} {r}（{dir}）の停留所が見つかりません",
  "No transit legs for ETA": "ETA 対象の交通区間がありません",
  "No usable stops after merge for {ag} {r}": "{ag} {r}のマージ後に利用可能な停留所がありません",
  "No valid coordinates in JSON": "JSONに有効な座標がありません",
  "No {mode} stops matched — try another name": "{mode} の停留所が一致しませんでした — 別の名称をお試しください",
  "No, use cloud only": "いいえ、クラウドのみ使用します",
  "Not now": "今はしない",
  "Notes for moderators": "モデレーター用メモ",
  "Nothing in box": "ボックス内に何もありません",
  "Nothing to confirm": "確認するものはありません",
  "Nothing to redo": "やり直すものはありません",
  "Nothing to revert": "戻すものはありません",
  "Nothing to undo": "元に戻すものはありません",
  "Now": "今",
  "Octopus Adult/Elderly": "オクトパス 大人／長者",
  "Octopus Child": "オクトパス 子供",
  "Octopus JoyYou Cards (60–64)": "JoyYou カード（60–64 歳）",
  "Octopus JoyYou Cards (65+)": "JoyYou カード（65 歳以上）",
  "Octopus Student": "オクトパス 学生",
  "Off": "オフ",
  "Offline Data": "オフラインデータ",
  "Offline data": "オフラインデータ",
  "Offline — using downloaded data": "オフライン — ダウンロード済みデータを使用",
  "Offline data ready": "オフラインデータの準備ができました",
  "On": "オン",
  "Onboarding": "オンボーディング",
  "Open source & data licenses": "オープンソースとデータライセンス",
  "Operator / mode": "事業者／モード",
  "Operator and route required": "事業者と路線が必要です",
  "Opposite": "反対方向",
  "Optional experimental features. You can change these anytime in Settings.": "任意の試験的機能です。いつでも設定で変更できます。",
  "Origin": "出発地",
  "Origin set to current location": "出発地を現在地に設定しました",
  "Origin suggestions": "出発地の候補",
  "Original path (before)": "元の経路（変更前）",
  "Other / joint": "その他／共同運行",
  "Outbound / O / UP / seq 1": "上り／O／UP／seq 1",
  "Outside service": "運行時間外",
  "Outside service hours": "運行時間外",
  "Override path loaded{id} · {n} pts": "オーバーライドパス{id}を読み込み · {n} ポイント",
  "Path cleared": "パスをクリアしました",
  "Path contributions are desktop-only (wide screen + mouse/trackpad).": "パス投稿はデスクトップ限定です（ワイド画面＋マウス／トラックパッド）。",
  "Path loaded · {stops} stops · {n} pts (live densify)": "パスを読み込み · 停留所 {stops} · {n} pts（ライブ高密度化）",
  "Path mode: drag hollow green handles · click path to insert · Alt+click delete · B for select": "パスモード：緑の中空ハンドルをドラッグ · パスをクリックで挿入 · Alt+クリックで削除 · Bで選択",
  "Path redone": "パスをやり直しました",
  "Path turning points (V)": "経路の曲がり角（V）",
  "Path turns": "経路の曲がり",
  "Path turns mode (V)": "パス角モード（V）",
  "Path unchanged — debug overlay shows why": "パスは変更されませんでした — デバッグオーバーレイに理由が表示されます",
  "Path undone": "パスを元に戻しました",
  "Pick a via place from the list, or clear Via": "リストから経由地を選ぶか、経由をクリアしてください",
  "Planning via {place}…": "{place} 経由で計画中…",
  "Planning…": "計画中…",
  "Pin": "ピン留め",
  "Pin plan": "ピン留め",
  "Pin route": "路線をピン留め",
  "Pin stop": "停留所をピン留め",
  "Pin this route to the toolbar": "この路線をツールバーにピン留め",
  "Pin this stop": "この停留所をピン留め",
  "Pin this trip": "この経路をピン留め",
  "Pinned": "ピン留め済み",
  "Pinned Routes": "ピン留めした停留所",
  "Pinned Stops": "ピン留めした停留所",
  "Pinned routes": "ピン留めした停留所",
  "Pinned stops": "ピン留めした停留所",
  "Pinned Trips": "ピン留めした経路",
  "Nothing pinned yet": "ピン留めはまだありません",
  "Pin trip plans from Plan Results, or open a route, pick a stop, then tap Pin.": "検索結果から経路をピン留めするか、路線の停留所を開いてピン留めしてください。",
  "Pin a route stop or trip plan": "停留所または経路をピン留め",
  "No pinned items": "ピン留めなし",
  "Show detail": "詳細を表示",
  "Open pinned {id}": "ピン留めした {id} を開く",
  "Open {n} pinned stops": "ピン留めした停留所 {n} 件を開く",
  "Open {n} pinned trips": "ピン留めした経路 {n} 件を開く",
  "Open {n} pinned items": "ピン留め {n} 件を開く",
  "Place": "場所",
  "Place search / reverse geocoding (service).": "場所検索／逆ジオコーディング（サービス）。",
  "Place search returned invalid JSON — is /geocode proxy running?": "場所検索が無効なJSONを返しました — /geocode プロキシは実行中ですか？",
  "Places": "場所",
  "Places · tap to plan trip": "場所 · タップで経路を検索",
  "Plan Results": "経路の候補",
  "Plan failed: {msg}": "経路検索に失敗：{msg}",
  "Plan trip": "経路を検索",
  "Platform {p}": "{p} 番ホーム",
  "Please get on the {noun} at {place}": "{place} で{noun}にご乗車ください",
  "Please get on the {noun} at {station}": "{station} で{noun}にご乗車ください",
  "Please review and accept all terms and policies to continue.": "続行するには、すべての規約とポリシーを確認して同意してください。",
  "Please review and accept our Terms of Service and Privacy Policy to continue.": "続行するには、利用規約とプライバシーポリシーをご確認のうえ同意してください。",
  "Predicted bus positions (busPositionEngine, trafficSpeed, busSchedules). Source under GNU GPLv3 only; see licenses/GPL-3.0.txt.": "予測バス位置（busPositionEngine、trafficSpeed、busSchedules）。ソースは GNU GPLv3 のみ。licenses/GPL-3.0.txt を参照。",
  "Predicted Live Positions are for reference only.": "予測されたバス位置は参考用です。",
  "Prediction accuracy": "予測精度",
  "Prefer": "優先",
  "Prefer data source": "データソースの優先",
  "Prefer {label}": "優先：{label}",
  "Prefer {prefer} data": "{prefer} データを優先",
  "Prefer {prefs}": "優先：{prefs}",
  "Preparing manifest…": "マニフェストを準備中…",
  "Preparing offline data…": "オフラインデータを準備中…",
  "Preview only —": "プレビューのみ —",
  "Preview: {snap} snapped · {raw} raw · {dens} densified · {fail} kept · {before}→{after} pts — Confirm or Revert": "プレビュー：スナップ {snap} · 生 {raw} · 高密度化 {dens} · 保持 {fail} · {before}→{after} pts — 確認または元に戻す",
  "Privacy Policy": "プライバシーポリシー",
  "Profile": "プロフィール",
  "Profile menu": "プロフィールメニュー",
  "Published override loaded{id} · {n} path pts · {stops} stops. Edit & re-submit to improve, or Follow roads (R).": "公開オーバーライド{id}を読み込み · パスポイント {n} · 停留所 {stops}。編集して再送信で改善、または道路追従（R）。",
  "QR Code Adult/Elderly": "QR コード 大人／長者",
  "QR Code Child": "QR コード 子供",
  "RBS": "レジデントバス",
  "Re-run onboarding": "オンボーディングをやり直す",
  "Recommended": "おすすめ",
  "Redo": "やり直す",
  "Redo (⌘/Ctrl+Shift+Z or ⌘/Ctrl+Y)": "やり直す（⌘/Ctrl+Shift+Z または ⌘/Ctrl+Y）",
  "Redo · {n} path pts · {u} undo · {r} redo": "やり直す · パスポイント {n} · 元に戻せる {u} · やり直せる {r}",
  "Reload": "再読み込み",
  "Reload now to fully apply the new language?": "新しい言語を完全に適用するには再読み込みが必要です。今すぐ再読み込みしますか？",
  "Reload once so the service worker is active": "service worker を有効にするため、一度再読み込みしてください",
  "Reload to apply language?": "言語を適用するには再読み込みしますか？",
  "Required for “GitHub account” submit.": "「GitHub アカウント」での投稿に必要です。",
  "Reset departure time to now": "出発時刻を今にリセット",
  "Reset to now (UTC+8)": "今（UTC+8）にリセット",
  "Residents' Bus Services (RBS, e.g. Ma Wan NR330/NR332 and Discovery Bay DB routes) charge a lower fare when paying with a registered Octopus card. Off = visitor fare.": "レジデントバス（RBS、例：馬湾 NR330/NR332、愉景湾 DB 路線）は登録済みオクトパスカードで支払うと運賃が安くなります。オフ = 観光客運賃。",
  "Restart now": "今すぐ再起動",
  "Restart to load the latest data from the cloud.": "再起動してクラウドの最新データを読み込みます。",
  "Resume a downloaded draft (or drop a": "ダウンロードした下書きを再開（または",
  "Restored your in-progress edit": "編集中の内容を復元しました",
  "Retry": "再試行",
  "Revert": "元に戻す",
  "Review the map · Confirm to keep · Revert to undo": "地図を確認 · 確定で保持 · 戻すで元に戻す",
  "Ride {n} stop{s}": "{n} 駅乗車",
  "Road assistant failed": "道路アシスタントが失敗しました",
  "Road assistant: nothing changed — see map legend (grey=original, amber=kept raw).": "道路アシスタント：変更はありません — 地図の凡例を参照（グレー=元、琥珀=生データ保持）。",
  "Road assistant: snapping vertices onto streets (keeps all your points)…": "道路アシスタント：頂点を道路にスナップ中（すべてのポイントを保持）…",
  "Road assistant: {msg}": "道路アシスタント：{msg}",
  "Road-network geometry for bus-route snapping (service; data © OSM contributors).": "バス路線のスナップ用道路ネットワーク形状（サービス；データ © OSM コントリビューター）。",
  "Route / fare dataset used for GMB and ferry fare fallbacks; used per its citation notice (HK Bus Crawling @2021).": "ミニバスとフェリーの運賃フォールバックに使用する路線／運賃データセット；引用表示に従って使用（HK Bus Crawling @2021）。",
  "Route / line": "路線／線区",
  "Route detail": "路線の詳細",
  "Route detail actions": "路線詳細の操作",
  "Route preferences": "経路の優先設定",
  "Router failed: {msg}": "ルーターエラー：{msg}",
  "Router graph failed to load": "ルーターグラフの読み込みに失敗しました",
  "Routes": "路線",
  "Runtime open source": "実行時オープンソース",
  "Same rates as Octopus Adult": "オクトパス大人と同額",
  "Same rates as Octopus Adult/Elderly": "オクトパス大人／長者と同額",
  "Same rates as Octopus Child": "オクトパス子供と同額",
  "Sched": "時刻表",
  "SCHEDULED": "時刻表",
  "Saved locally to the overrides pending folder. Open the review page or merge via npm run overrides:merge.": "overrides pendingフォルダにローカル保存されました。レビューページを開くか、npm run overrides:mergeでマージしてください。",
  "Scheduled departures": "時刻表発車",
  "Search": "検索",
  "Search destination or route": "目的地または路線を検索",
  "Search failed": "検索に失敗しました",
  "Search unavailable — run npm run dev (needs /geocode proxy), or tap the map": "検索できません — npm run dev を実行（/geocode プロキシが必要）、または地図をタップしてください",
  "Searching…": "検索中…",
  "Segment densified + inserted mids": "区間を密化し中間点を挿入",
  "Segment left as-is": "区間はそのまま",
  "Segment {n}/{total}": "セグメント {n}/{total}",
  "Select": "選択",
  "Select a route first": "先に路線を選択してください",
  "Select an operator / mode (KMB, GMB, MTR, AEL, LRT, …).": "事業者／モードを選択してください（KMB、GMB、MTR、AEL、LRT、…）。",
  "Select at least one bus company": "バス事業者を 1 つ以上選択してください",
  "Select at least one preference": "優先設定を 1 つ以上選択してください",
  "Select at least one traffic method": "交通手段を 1 つ以上選択してください",
  "Select mode (B)": "選択モード（B）",
  "Select mode (B) — box-select offset points": "選択モード（B）— オフセットポイントをボックス選択",
  "Select mode (B) — box-select · O for offsets": "選択モード（B）— ボックス選択 · Oでオフセット",
  "Select mode: drag a box on the map · amber = offset >{n}m · Delete/Backspace removes selected": "選択モード：地図上でボックスをドラッグ · 琥珀色 = オフセット >{n}m · Delete/Backspaceで選択を削除",
  "Select offsets": "オフセットを選択",
  "Select operator and enter route number first": "先に事業者を選択し路線番号を入力してください",
  "Selected {n} offset points (>{m}m from route backbone). Delete to clean, or box-select more.": "{n} 個のオフセットポイントを選択（路線バックボーンから >{m}m）。削除して整理するか、さらにボックス選択してください。",
  "Selection cleared": "選択をクリアしました",
  "Select…": "選択…",
  "Service day mode": "運行日モード",
  "Settings": "設定",
  "Show ETA at this stop": "この停留所の ETA を表示",
  "Show live bus markers predicted from nearby ETA countdowns.": "近隣の駅の到着予想時刻から推定したバスのライブ位置マーカーを表示します。",
  "Show live markers predicted from nearby ETA countdowns.": "近隣の駅の到着予想時刻から推定したライブ位置マーカーを表示します。",
  "Show live markers on bus route maps — estimates stitched from the ETA countdowns of nearby stops, not official GPS.": "バス路線マップにリアルタイムマーカーを表示 — 位置は公式 GPS ではなく、近隣停留所の ETA カウントダウンから補間した推定値。",
  "Show live markers on route maps — estimates stitched from the ETA countdowns of nearby stops, not official GPS.": "路線マップにリアルタイムマーカーを表示 — 位置は公式 GPS ではなく、近隣停留所の ETA カウントダウンから補間した推定値。",
  "Show route details": "路線の詳細を表示",
  "Show the “Beta Feature” disclaimer while live bus positions are active. Swipe the banner up to hide it for the session.": "バスのリアルタイム位置が有効な間、「ベータ版機能」の免責バナーを表示します。バナーを上にスワイプするとこのセッション中は非表示になります。",
  "Show the “Beta Feature” disclaimer while the Live Position Engine is active. Swipe the banner up to hide it for the session.": "ライブ位置エンジンが有効な間、「ベータ版機能」の免責バナーを表示します。バナーを上にスワイプするとこのセッション中は非表示になります。",
  "Showing @{mode} stops": "@{mode} の停留所を表示中",
  "Signed in as @{login}": "@{login} としてログイン中",
  "Similar override ({from}) · {n} pts": "類似オーバーライド（{from}）· {n} ポイント",
  "Simplest": "最も簡単",
  "Single Ride Ticket/Cash": "1 回券／現金",
  "Skip": "スキップ",
  "Skipped a via that is too close to another point": "他の地点に近すぎる経由地をスキップしました",
  "Snap link (old → new)": "スナップリンク（旧 → 新）",
  "Snap visuals": "スナップ表示",
  "Snap your path onto nearby road edges only — does not re-route (R)": "経路を近くの道路エッジにスナップするだけ — 経路探索はやり直しません（R）",
  "Snapping vertices to nearest road…": "頂点を最寄りの道路にスナップ中…",
  "Snaps your vertices onto nearby streets. Never deletes points — only adds road detail where OSRM can; weak sections stay as you drew them. Result is drawn on the map as a calculation overlay.": "頂点を近くの道路にスナップします。点を削除することはありません — OSRM が可能な箇所にのみ道路の詳細を追加し、弱い区間は描いたままにします。結果は計算オーバーレイとして地図上に描画されます。",
  "Standard": "標準",
  "Start Using App": "アプリを始める",
  "Starting download: {filename}": "ダウンロードを開始：{filename}",
  "Station names show in Chinese for 廣東話, 繁體中文 and 简体中文; English for others.": "駅名：広東語・繁体中文・简体中文は中国語、その他の言語は英語で表示されます。",
  "Step {n} of {m}": "ステップ {n} / {m}",
  "Stop": "停留所",
  "Stop {n}": "停留所 {n}",
  "Stops on route": "路線の停留所",
  "Sub-page actions": "サブページの操作",
  "Submit failed": "送信に失敗しました",
  "Submit for review": "レビューに提出",
  "Submit for review — mods publish after check.": "レビューに提出 — モデレーターが確認後に公開します。",
  "Submit method": "提出方法",
  "Submit successful": "送信に成功しました",
  "Submitting…": "提出中…",
  "Swap origin and destination": "出発地と目的地を入れ替え",
  "Switch branch": "支線を切り替え",
  "Switch operator": "事業者を切り替え",
  "Switch branch: {cur} ⇄ {other}": "支線を切り替え：{cur} ⇄ {other}",
  "Switch Departure": "出発を切り替え",
  "Switch direction": "方向を切り替え",
  "Search route": "路線を検索",
  "Search a route first": "先に路線を検索",
  "Search and pick a route first": "先に路線を検索して選んでください",
  "Loading directions…": "方面を読み込み中…",
  "{n} directions on this route": "この路線は {n} 方面あります",
  "Tap the map to set": "地図をタップして設定",
  "Tap the map to set destination": "地図をタップして目的地を設定",
  "Tap the map to set origin": "地図をタップして出発地を設定",
  "Tap the map to set via": "地図をタップして経由地を設定",
  "Terms": "規約",
  "Terms & Privacy": "規約とプライバシー",
  "Terms of Service": "利用規約",
  "The map's graphics engine keeps failing. Reload the page to try again.": "地図のグラフィックスエンジンが繰り返し失敗しています。ページを再読み込みしてください。",
  "The terms and policies you agreed to when you first set up Travelers.": "初回セットアップで同意した利用規約とポリシーです。",
  "The transit data has been refreshed on the server. Re-download the offline set to get the latest routes, stops and fares?": "サーバーの交通データが更新されました。最新の路線・停留所・運賃を取得するため、オフラインセットを再ダウンロードしますか？",
  "Third-party software, fonts, and data used by Travelers, with license identifiers and attribution links for compliance.": "Travelers が使用するサードパーティのソフトウェア・フォント・データ。コンプライアンスのためライセンス識別子と帰属リンク付き。",
  "Third-party software, fonts, and data used by Travelers, with license identifiers and attribution links for compliance. Last updated 12 Aug 2026 — versions are package ranges; lockfile pins apply at build time. SPDX identifiers as declared upstream; full license text is in each project’s distribution.": "Travelers が使用するサードパーティのソフトウェア・フォント・データ。コンプライアンスのためライセンス識別子と帰属リンク付き。最終更新 2026 年 8 月 12 日 — バージョンはパッケージ範囲；ビルド時に lockfile で固定。SPDX 識別子は上流の宣言に準拠；ライセンス全文は各プロジェクトの配布物に記載。",
  "This browser can't render the map — it needs WebGL2 graphics. Update Chrome or Android System WebView and reload.": "このブラウザでは地図を表示できません — WebGL2 が必要です。Chrome または Android System WebView を更新して再読み込みしてください。",
  "This will delete all cached data, preferences, and onboarded state. Are you sure?": "すべてのキャッシュデータ、設定、オンボーディング状態が削除されます。よろしいですか？",
  "Ticket / fare type": "乗車券／運賃種別",
  "Ticket type": "乗車券種別",
  "Ticket type used for trip plans and bus boarding prices on route details.": "経路検索と路線詳細のバス乗車料金に使用する乗車券種別。",
  "Tickets": "切符",
  "Tile archive format and client loader (Protomaps).": "タイルアーカイブ形式とクライアントローダー（Protomaps）。",
  "Timetable · {schedN}/{total} routes · {t}": "時刻表 · {schedN}/{total} 路線 · {t}",
  "To": "目的地",
  "To {dest}": "{dest} 行き",
  "Traffic method": "交通手段",
  "Traffic methods": "交通手段",
  "Traffic methods. None selected shows all.": "交通手段。未選択の場合はすべて表示。",
  "Transfer walk": "乗り換え徒歩",
  "Transit": "交通",
  "Transit data (Hong Kong)": "交通データ（香港）",
  "Transport Department open data": "運輸署オープンデータ",
  "Travelers panel": "Travelers パネル",
  "Treated as adult Octopus rates": "大人オクトパス運賃として扱われます",
  "Trip Plan": "経路検索",
  "Trip Plan · to {name}": "経路検索 · {name} 行き",
  "Trip detail": "経路の詳細",
  "Trip plan pinned": "経路をピン留めしました",
  "Trip plan unpinned": "経路のピン留めを解除しました",
  "Trip-planning engine (RAPTOR); compiled WASM vendored in this repo (Wheels Labs / Wheels Softworks).": "経路検索エンジン（RAPTOR）；コンパイル済み WASM を本リポジトリに同梱（Wheels Labs / Wheels Softworks）。",
  "Try another filter or search term": "別のフィルターや検索語をお試しください",
  "Try different locations or a later departure.": "別の場所またはより遅い出発をお試しください。",
  "Turning off the banner means you understand and agree that predicted live bus positions are inaccurate and for reference only.": "バナーを非表示にすることは、予測されたライブバス位置が不正確で参考用のみであることを理解し同意したものとみなされます。",
  "UI icons, loaded from Google Fonts (Google LLC).": "UI アイコン、Google Fonts から読み込み（Google LLC）。",
  "UI typeface, loaded from Google Fonts (The Montserrat Project Authors).": "UI フォント、Google Fonts から読み込み（The Montserrat Project Authors）。",
  "UNLOOP MORGAN Universal Terms of Use for Open-Source Software": "UNLOOP MORGAN オープンソースソフトウェア共通利用規約",
  "Undo": "元に戻す",
  "Undo (⌘/Ctrl+Z)": "元に戻す（⌘/Ctrl+Z）",
  "Undo · {n} path pts · {u} undo · {r} redo": "元に戻す · パスポイント {n} · 元に戻せる {u} · やり直せる {r}",
  "Unknown MTR line “{line}”. Try TWL, ISL, KTL, TML, EAL, TCL, TKL, SIL, DRL, or AEL.": "不明なMTR路線「{line}」です。TWL、ISL、KTL、TML、EAL、TCL、TKL、SIL、DRL、AELをお試しください。",
  "Unpin": "固定を解除",
  "Unpin plan": "ピン留めを外す",
  "Unpin stop": "ピン留めを外す",
  "Unpin this trip": "この経路の固定を解除",
  "Unpinned {id}": "{id} のピン留めを解除しました",
  "Update available": "更新があります",
  "Update data": "データを更新",
  "Update frequency": "更新頻度",
  "Update now": "今すぐ更新",
  "Updated —": "更新済み —",
  "Updated {n}h ago": "{n} 時間前に更新",
  "Updated {n}m ago": "{n} 分前に更新",
  "Updated {n}s ago": "{n} 秒前に更新",
  "Uploading path for review": "レビュー用に経路をアップロード中",
  "Use current location": "現在地を使用",
  "Use current location as origin": "現在地を出発地として使用",
  "Use Resident Fare on RBS": "RBS でレジデント運賃を使用",
  "Usual": "平日",
  "Usual uses weekday timetables; Holiday uses Sunday / public-holiday service.": "平日は月〜金の時刻表を使用；休日は日曜／祝日ダイヤを使用。",
  "V path · S visual stops · R follow roads · Tab switch. Official greys stay fixed.": "V パス · S ビジュアル停留所 · R 道路追従 · Tab 切替。公式グレーは固定のまま。",
  "Vector basemap": "ベクターベースマップ",
  "Vertex kept raw (OSRM weak)": "頂点はそのまま（OSRM 弱）",
  "Vertex snapped to road": "頂点を道路にスナップ",
  "Visit your PR": "PR を開く",
  "Visit {visitN} of {visitTotal} on this route": "この路線の {visitTotal} 回中 {visitN} 回目",
  "Visual stop pins (S) — official stays fixed": "ビジュアル停留所ピン（S）— 公式停留所は固定",
  "Visual stops": "ビジュアル停留所",
  "Visual stops mode (S)": "ビジュアル停留所モード（S）",
  "Visual stops mode (S) — drag orange pins": "ビジュアル停留所モード（S）— オレンジのピンをドラッグ",
  "Visual stops re-projected onto path · official coords still fixed": "ビジュアル停留所をパスに再投影しました · 公式座標は固定のまま",
  "Visual stops snapped to path (official unchanged)": "ビジュアル停留所をパスにスナップしました（公式位置は不変）",
  "Visual stops: no stops loaded — Load calculated path first": "ビジュアル停留所：停留所が読み込まれていません — 先に計算済みパスを読み込んでください",
  "Visual stops: {n} orange pins · grey ghost only if moved from official · drag to adjust": "ビジュアル停留所：{n} 個のオレンジピン · 公式位置から動かした場合のみグレーのゴースト · ドラッグで調整",
  "Via": "経由",
  "Via {n}": "経由 {n}",
  "Via cleared": "経由をクリアしました",
  "Via is the same as the destination": "経由地が目的地と同じです",
  "Via is the same as the origin": "経由地が出発地と同じです",
  "Via suggestions": "経由地の候補",
  "Walk": "徒歩",
  "Walk to {dest}": "{dest} まで徒歩",
  "Walk to {to}": "{to} まで徒歩",
  "Walk to destination": "目的地まで徒歩",
  "Walk to station": "駅まで徒歩",
  "Walk the free link to {place}": "無料連絡通路で {place} まで徒歩",
  "Welcome to MORGAN Travelers": "MORGAN Travelers へようこそ",
  "Welcome!": "ようこそ！",
  "Yes, cache all data": "はい、すべてのデータをキャッシュします",
  "You were running on downloaded data. Restart to load the latest data from the cloud.": "ダウンロード済みデータで実行していました。再起動してクラウドの最新データを読み込んでください。",
  "Your name (optional)": "お名前（任意）",
  "You can add up to {n} vias": "経由地は最大 {n} 件まで追加できます",
  "Your path was saved to the review queue.": "パスがレビューキューに保存されました。",
  "Your path was submitted and a pull request was opened from your GitHub account.": "パスが送信され、GitHubアカウントからプルリクエストが開かれました。",
  "Your path was submitted and a review pull request was opened by the site bot.": "パスが送信され、レビューのプルリクエストがサイトのボットによって開かれました。",
  "Your path was submitted for review.": "パスがレビュー用に送信されました。",
  "another route": "別の路線",
  "as {author}": "{author} として",
  "auto after load": "読み込み後に自動",
  "cycle": "切替",
  "default": "デフォルト",
  "desktop": "デスクトップ",
  "e.g. Central Station · @MTR @LRT @Bus": "例：中環駅 · @MTR @軽鉄 @バス",
  "e.g. Yuen Long Station": "例：元朗駅",
  "e.g. Times Square · meet here": "例：タイムズスクエア · ここで待ち合わせ",
  "e.g. via Mei Tung Street, not terminus bay": "例：バスターミナルではなく美東街経由",
  "filters.": "フィルター。",
  "fork (credited to you).": "フォークからPRを開く（あなたに帰属）。",
  "id {id}": "id {id}",
  "min": "分",
  "multi-select": "複数選択",
  "on this panel).": "このパネルにドロップ）。",
  "path ·": "パス ·",
  "published path that covers the same corridor; otherwise live OSRM.": "同じ区間をカバーする公開パス；ない場合はライブOSRM。",
  "roads ·": "道路 ·",
  "route {r}": "路線 {r}",
  "select ·": "選択 ·",
  "similar": "類似の",
  "stops ·": "停留所 ·",
  "to discard.": "破棄するには。",
  "to keep,": "保持するには、",
  "visual stop pins": "ビジュアル 停留所ピン",
  "{base} - Platform {p}": "{base} - {p} 番ホーム",
  "{h} h": "{h} 時間",
  "{h} h {m} min": "{h} 時間 {m} 分",
  "{kindLabel} {routeId} → {dest}": "{kindLabel} {routeId} → {dest} 行き",
  "{n} min": "{n} 分",
  "1 min": "1 分",
  "your": "あなたの",
  "{n} offset points selected": "{n} 個のオフセットポイントを選択",
  "{n} path points on map (stop names unavailable).": "地図上に {n} 個のパスポイント（停留所名なし）。",
  "{n} pinned route{s}": "固定中の {n} 停留所{s}",
  "{n} pinned stop{s}": "固定中の {n} 停留所{s}",
  "{n} plan(s) · {ms} ms": "{n} 件の経路 · {ms} ms",
  "{n} plan(s) via {place} · {ms} ms": "{place} 経由 {n} 件 · {ms} ms",
  "{n} points selected": "{n} ポイント選択中",
  "{n} points selected · Delete/Backspace to remove · Shift+drag to add": "{n} ポイント選択中 · Delete/Backspaceで削除 · Shift+ドラッグで追加",
  "{n} stops": "{n} 停留所",
  "{n}m": "{n} 分",
  "{pts} pts": "{pts} ポイント",
  "· green rings = path · orange = visual stop · grey = official fixed": "· 緑のリング = パス · オレンジ = ビジュアル 停留所 · グレー = 公式固定",
};